// The site's main sections: the header menu and the first footer row. Legal pages stay in a
// smaller footer row so they don't compete with these for Google sitelinks.
export const MAIN_LINKS: Array<[string, string]> = [
    ['/features', 'Features'],
    ['/dating-safety', 'Dating Safety'],
    ['/faq', 'FAQ'],
    ['/blog', 'Blog'],
];
